import axios from 'axios';

// 处理频繁请求，用于中断上一个请求
// 声明一个数组用于存储每个请求的取消函数和axios标识
let pending = []
const CancelToken = axios.CancelToken
let removePending = (config) => {
  for (let p in pending) {
    if (pending[p].u === config.url + JSON.stringify(config.data) + '&' + config.method) {
      pending[p].f()
      pending.splice(p, 1)
    }
  }
}

export function request(config) {
  // 1.创建axios的实例
  const instance = axios.create({
    // baseURL: 'http://localhost:8889',
    // baseURL: 'http://192.168.164.83:8878',
    baseURL: 'https://ngdc.cncb.ac.cn/', // 这里不能再加ascancer了，因为后端路由已经加了
    timeout: 100000,
  });

  // 2.axios的拦截器
  // 2.1.请求拦截的作用
  instance.interceptors.request.use(config => {

    removePending(config);
    config.cancelToken = new CancelToken((c) => {
      // 这里的axios标识我是用请求地址&请求方式拼接的字符串，当然你可以选择其他的一些方式
      pending.push({
        u: config.url + JSON.stringify(config.data) + '&' + config.method,
        f: c
      });
    })
    return config
  }, error => {
    return Promise.reject(error);
  })

  // 2.2.响应拦截
  instance.interceptors.response.use(res => {
    // 取消响应
    removePending(res.config)
    return res.data
  }, error => {
    if (axios.isCancel(error)) { // 取消请求的情况下，终端Promise调用链
      return new Promise(() => {});
    } else {
      return Promise.reject(error);
    }
  })

  // 3.发送真正的网络请求
  return instance(config)
}